import { useEffect, useState } from "react";
import { startOfMonth, addDays, format, isSameMonth } from "date-fns";
import { toast } from "sonner";
import { api, ymd, errMsg } from "@/lib/api";
import { MonthCalendar } from "@/components/MonthCalendar";
import { StepHeader, NextButton } from "./StepHeader";

export const StepTerm = ({ ctx }) => {
  const { b, update, go } = ctx;
  const [month, setMonth] = useState(startOfMonth(b.date ? new Date(`${b.date}T00:00`) : new Date()));
  const [av, setAv] = useState(null);

  useEffect(() => {
    api.get("/availability", { params: { month: format(month, "yyyy-MM") } })
      .then((r) => setAv(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [month]);

  const now = new Date();
  const today = ymd(now);
  const nowHM = format(now, "HH:mm");
  const maxDate = ymd(addDays(now, av?.days_ahead ?? 60));
  const isTaken = (ds, t) => (av?.taken[ds] || []).includes(t) || (ds === today && t <= nowHM);
  const dayDisabled = (ds) => {
    if (!av || ds < today || ds > maxDate) return true;
    const wd = (new Date(`${ds}T00:00`).getDay() + 6) % 7;
    if (!av.working_days.includes(wd) || av.blocked_days.includes(ds)) return true;
    return av.slots.every((t) => isTaken(ds, t));
  };

  return (
    <section data-testid="step-term">
      <StepHeader onBack={() => go("package")} num={3} title="Wybierz termin" sub="Znajdź dogodny termin i godzinę." />
      <div className="grid lg:grid-cols-[1.3fr_1fr] gap-6 rise d1">
        <div className="panel p-6">
          <MonthCalendar month={month} onMonthChange={setMonth} canPrev={!isSameMonth(month, now)}
            isDisabled={dayDisabled} selected={b.date} onSelect={(ds) => update({ date: ds, time: null })} />
        </div>
        <div className="panel p-6">
          <h3 className="font-display font-semibold mb-5">Dostępne godziny</h3>
          {!b.date ? <p data-testid="hours-placeholder" className="text-sm text-muted-foreground">Najpierw wybierz dzień w kalendarzu.</p> : (
            <div className="grid grid-cols-2 gap-3">
              {av?.slots.map((t) => {
                const taken = isTaken(b.date, t);
                const sel = b.time === t;
                return (
                  <button key={t} data-testid={`time-slot-${t}`} disabled={taken} onClick={() => update({ time: t })}
                    className={`py-3 rounded-md border text-sm font-semibold transition-colors ${sel ? "bg-primary text-black border-primary" : taken ? "border-white/5 text-white/20 line-through cursor-not-allowed" : "border-white/15 hover:border-primary/70"}`}>
                    {t}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-end mt-8">
        <NextButton disabled={!b.date || !b.time} onClick={() => go("details")} />
      </div>
    </section>
  );
};
